import qs from "query-string";
import { useQuery } from "react-query";
import {
    GetPengeluaranResponse,
    ParamsGetPengeluaran,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (params: ParamsGetPengeluaran) => {
    const apiGetPengeluaran = qs.stringifyUrl({
        url: "api/biaya",
        query: {
            ukmId: params.ukmId,
            page: params.page,
            size: params.size,
            search: `${params.search}`,
            tanggalAwal: params.tanggalAwal,
            tanggalAkhir: params.tanggalAkhir,
        },
    });
    const { data } = await axios.get<GetPengeluaranResponse>(apiGetPengeluaran);
    return data.data;
};

export default function usePengeluaran(params: ParamsGetPengeluaran) {
    return useQuery<GetPengeluaranResponse["data"]>(
        ["pengeluaran", params],
        () => handleRequest(params),
    );
}
